/**
 * Payment Cancelled Page
 * 
 * Displayed when user cancels Stripe payment
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-red-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-4">
            <Icon name="x-circle" size={32} className="text-gray-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Betalning Avbruten
          </h1>
          <p className="text-gray-600">
            Du avbröt betalningen. Inga pengar har dragits från ditt konto.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <div className="flex items-start space-x-3">
            <Icon name="info" size={20} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-left">
              <p className="text-sm text-blue-800 font-medium mb-1">
                Behöver du hjälp?
              </p>
              <p className="text-xs text-blue-700">
                Kontakta vår support om du stötte på problem under betalningen.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <Link 
            to="/client/chat"
            className="inline-flex items-center justify-center w-full px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Köp Credits Senare
          </Link>
          
          <Link 
            to="/client/chat"
            className="inline-flex items-center justify-center w-full px-4 py-2 bg-gray-200 text-gray-900 hover:bg-gray-300 font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Tillbaka till AI-terapin
          </Link>
        </div>

        <div className="mt-6">
          <Link 
            to="/contact" 
            className="text-xs text-gray-500 hover:text-gray-700 underline"
          >
            Kontakta Support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
